import { gql } from '@apollo/client';

export const LOCATIONS = gql`
    query Locations {
        locations {
            edges {
                node {
                    id
                    name
                    description
                    address
                    sortOrder
                    isActive
                }
            }
        }
    }
`;

export const LOCATION = gql`
    query Location($id: ID!) {
        location(id: $id) {
            id
            name
            description
            address
            sortOrder
            isActive
        }
    }
`;

export const ENTITY_TYPES = gql`
    query EntityTypes {
        entityTypes {
            edges {
                node {
                    id
                    name
                    slug
                    description
                    icon
                    color
                    minDurationMinutes
                    maxDurationMinutes
                    slotIntervalMinutes
                    advanceBookingDays
                    sameDayBooking
                    maxActiveBookingsPerMember
                    requiresApproval
                    cancellationDeadlineHours
                    isActive
                }
            }
        }
    }
`;

export const ENTITY_TYPE = gql`
    query EntityType($id: ID!) {
        entityType(id: $id) {
            id
            name
            slug
            description
            icon
            color
            minDurationMinutes
            maxDurationMinutes
            slotIntervalMinutes
            advanceBookingDays
            sameDayBooking
            maxActiveBookingsPerMember
            requiresApproval
            cancellationDeadlineHours
            isActive
        }
    }
`;

export const ENTITIES = gql`
    query Entities($locationId: ID, $entityTypeId: ID, $activeOnly: Boolean) {
        entities(locationId: $locationId, entityTypeId: $entityTypeId, activeOnly: $activeOnly) {
            edges {
                node {
                    id
                    uuid
                    name
                    description
                    capacity
                    minCapacity
                    equipment
                    displayToken
                    displayUrl
                    sortOrder
                    isActive
                    entityType {
                        id
                        name
                        slug
                        color
                    }
                    location {
                        id
                        name
                    }
                    availabilitySlots {
                        id
                        dayOfWeek
                        dayOfWeekDisplay
                        startTime
                        endTime
                    }
                    blockouts {
                        id
                        startDatetime
                        endDatetime
                        reason
                    }
                }
            }
        }
    }
`;

export const ENTITY = gql`
    query Entity($id: ID!) {
        entity(id: $id) {
            id
            uuid
            name
            description
            capacity
            minCapacity
            equipment
            displayToken
            displayUrl
            sortOrder
            isActive
            entityType {
                id
                name
                slug
                color
            }
            location {
                id
                name
            }
            availabilitySlots {
                id
                dayOfWeek
                dayOfWeekDisplay
                startTime
                endTime
            }
            blockouts {
                id
                startDatetime
                endDatetime
                reason
            }
        }
    }
`;

export const RESERVATIONS = gql`
    query Reservations($entityId: ID, $memberId: ID, $status: String, $fromDate: DateTime, $toDate: DateTime) {
        reservations(entityId: $entityId, memberId: $memberId, status: $status, fromDate: $fromDate, toDate: $toDate) {
            edges {
                node {
                    id
                    uuid
                    startDatetime
                    endDatetime
                    partySize
                    status
                    notes
                    internalNotes
                    customerName
                    isCancellable
                    durationMinutes
                    createdAt
                    entity {
                        id
                        name
                        entityType {
                            id
                            name
                            color
                        }
                        location {
                            id
                            name
                        }
                    }
                    member {
                        id
                        firstName
                        lastName
                        email
                        phone
                        allergies
                        dietRestrictions
                        likes
                        dislikes
                    }
                    walkInName
                    walkInPhone
                    walkInEmail
                }
            }
        }
    }
`;

export const RESERVATION = gql`
    query Reservation($id: ID!) {
        reservation(id: $id) {
            id
            uuid
            startDatetime
            endDatetime
            partySize
            status
            notes
            internalNotes
            customerName
            isCancellable
            durationMinutes
            entity {
                id
                name
                entityType {
                    id
                    name
                    color
                    cancellationDeadlineHours
                }
            }
            member {
                id
                firstName
                lastName
                email
                phone
                allergies
                dietRestrictions
                likes
                dislikes
            }
            walkInName
            walkInPhone
            walkInEmail
        }
    }
`;

export const ENTITY_AVAILABILITY = gql`
    query EntityAvailability($entityId: ID!, $date: Date!, $durationMinutes: Int) {
        entityAvailability(entityId: $entityId, date: $date, durationMinutes: $durationMinutes) {
            entity {
                id
                name
            }
            date
            availableSlots {
                startTime
                endTime
                isAvailable
            }
        }
    }
`;

export const SUGGESTED_ENTITIES = gql`
    query SuggestedEntities($entityTypeId: ID!, $date: Date!, $startTime: Time!, $durationMinutes: Int!, $partySize: Int) {
        suggestedEntities(entityTypeId: $entityTypeId, date: $date, startTime: $startTime, durationMinutes: $durationMinutes, partySize: $partySize) {
            id
            name
            capacity
            location {
                name
            }
            entityType {
                name
                color
            }
        }
    }
`;
